export default __webpack_public_path__ + "static/media/Star.c8759ff0.svg";